/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, bool, arrayOf,
    shape, string, number, func,
} from 'prop-types';
import { connect, useDispatch } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import classList from '../../../../utils/classList';
import EventDispatcher from '../../../../state/reducers/EventDispatcher';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = () => ({
    addressWrapper: { display: 'flex', 'align-items': 'start' },
    street: { flex: '1' },
});

const Address = (props) => {
    const { classes } = props;
    const {
        recipient,
        recipient: { address },
        handleGiftListEditRecipientClicked,
        handleRemoveRecipientClicked,
    } = props;

    if (!address) return null;

    const dispatch = useDispatch();
    const {
        street, apt, city, state, zipcode, country,
    } = address;
    return (
        <div
            className={classList(
                `${classes.addressWrapper}`,
                'margin-bottom-2x',
            )}
        >
            <div className={classes.street}>
                <div>
                    {street}
                    {apt ? ` ${apt}` : ''}
                </div>
                <div>{`${city}, ${state.id} ${zipcode}`}</div>
                <div className="margin-bottom">{country.name}</div>
                <button
                    className="edit-recipient-btn link"
                    onClick={() => {
                        handleGiftListEditRecipientClicked(recipient);
                        dispatch(trackEvent({
                            eventCategory: 'Gift List V1',
                            eventAction: 'Edit Recipient',
                            eventLabel: '',
                        }));
                    }}
                    type="button"
                >
                    Edit Address
                </button>
            </div>
            <button
                className="remove-recipient-btn link"
                onClick={() => {
                    handleRemoveRecipientClicked(recipient, null, 'GIFT_LIST');
                    dispatch(trackEvent({
                        eventCategory: 'Gift List V1',
                        eventAction: 'Delete Recipient',
                        eventLabel: '',
                    }));
                }}
                type="button"
            >
                Remove
            </button>
        </div>
    );
};

Address.defaultProps = {
    recipient: {},
    handleRemoveRecipientClicked: () => {},
    handleGiftListEditRecipientClicked: () => {},
};

Address.propTypes = {
    classes: object.isRequired,
    recipient: shape({
        AddressBookEntryId: string,
        ContactId: number,
        NamePrefix: string,
        FirstName: string,
        MiddleInitial: string,
        LastName: string,
        NameSuffix: string,
        RelationShip: string,
        NickName: string,
        EmailAddress: string,
        LastUpdateDate: string,
        PhoneNumber: string,
        AlternatePhoneNumber: string,
        Fax: string,
        EmployerName: string,
        NumberOfAddresses: number,
        DateOfBirth: string,
        Addresses: arrayOf(
            shape({
                AddressId: number,
                AddressBookEntryId: string,
                AddressType: string,
                AddressLineOne: string,
                AddressLineTwo: string,
                City: string,
                StateProvince: string,
                PostalCode: string,
                Country: string,
                IsPartialMatch: bool,
                IsUnknownAddress: bool,
                Latitude_degrees: number,
                Longitude_degrees: number,
                IsBillingAddress: bool,
                ContactId: number,
            }),
        ),
    }),
    handleGiftListEditRecipientClicked: func,
    handleRemoveRecipientClicked: func,
};

const mapDispatchToProps = (dispatch) => ({
    handleGiftListEditRecipientClicked: (recipient) => dispatch(EventDispatcher.handleGiftListEditRecipientClicked(recipient)),
    handleRemoveRecipientClicked: (recipient, AddressId, addressType) => dispatch(EventDispatcher.handleRemoveRecipientClicked(
        recipient,
        AddressId,
        addressType,
    )),
});

export default connect(
    null,
    mapDispatchToProps,
)(withStyles(styles)(Address));
